module.exports = __webpack_public_path__ + "img/y5.4f59bd2f.jpg";